import ChipSelect from './ChipSelect';
import _ from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import React from 'react';

function ChipSelectFormsy(props) {
  const importedProps = _.pick(props, [
    'children',
    'classes',
    'className',
    'defaultValue',
    'disabled',
    'fullWidth',
    'id',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'required',
    'textFieldProps',
    'variant',
    'isMulti',
    'options',
    'errorMessage',
    'color',
  ]);

  const [selectedOptions, setSelectedOptions] = React.useState([]);
  // value must be selected options with value and label

  // An error message is returned only if the component is invalid
  const { description, errorMessage, value, options, isMulti } = props;

  React.useEffect(() => {
    if (Array.isArray(value)) {
      setSelectedOptions(value);
    } else {
      setSelectedOptions([value]);
    }
  }, [value]);

  function handleSelectOptions(options) {
    let newOptions = [];
    if (Array.isArray(options)) {
      setSelectedOptions(options);
      newOptions = options;
    } else {
      setSelectedOptions([options]);
      const reformattedOptions = isMulti ? [options] : options;
      newOptions = reformattedOptions;
    }
    props.setValue(newOptions);
    if (props.onChange) {
      props.onChange(newOptions);
    }
  }

  const helperText = errorMessage || description;

  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={clsx(
        props.className,
        props.showRequired ? 'required' : '',
        props.showError ? 'error' : null,
      )}
      variant={importedProps.variant}
    >
      <ChipSelect
        {...importedProps}
        placeholder={props.label}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.alias}
        value={selectedOptions}
        onChange={handleSelectOptions}
        error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      />
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(ChipSelectFormsy));
